export const getDeviceDiff = (arr1, arr2) => {
  const diff = arr1.filter(({ id: id1 }) => !arr2.some(({ id: id2 }) => id2 === id1));

  return diff;
};

export const getSymmetricDifference = (arr1, arr2) => {
  const diff1 = getDeviceDiff(arr1, arr2);
  const diff2 = getDeviceDiff(arr2, arr1);

  return [...diff1, ...diff2];
};

const sortByKey = (array, key) =>
  array.sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });

export const getAlertDiff = (a1, a2) => {
  const differentObjects = [];
  const key = 'alertOn';

  const arr1 = sortByKey(a1, 'id');
  const arr2 = sortByKey(a2, 'id');

  if (arr1.length !== arr2.length) {
    return differentObjects;
  }

  arr1.forEach((obj1, index) => {
    const obj2 = arr2[index];

    if (obj1[key] !== obj2[key]) {
      differentObjects.push({ index, key, value1: obj1[key], value2: obj2[key] });
    }
  });

  return differentObjects;
};

export const mapDevicesToPopup = (devices, alertId, selectedAlerts = []) => devices.map(d => {
  const founded = selectedAlerts.find(sa => sa.id === d.id);

  if (founded) {
    return {
      ...d,
      alertOn: founded.alertOn,
      showAlertIcon: founded.showAlertIcon
    };
  }

  return {
    ...d,
    alertOn: !!alertId,
    showAlertIcon: !!alertId
  };
});

export const setAlertToDevice = (device, selectedAlert, isEnabled) => {
  const isSelectedAlert = selectedAlert.find(selectedAlerts => selectedAlerts.id === device.id);

  if (isSelectedAlert) {
    return ({
      ...device,
      alertOn: !isSelectedAlert.alertOn
    });
  }

  return ({ ...device, alertOn: isEnabled });
};

export const mergeWithAlerts = (selectedDevices = [], selectedAlerts = []) => {
  const deviceWithAlerts = selectedDevices.map(selectedDevice => {
    const selectedDeviceAlert = selectedAlerts.find(alertDevice =>
      alertDevice.id === selectedDevice.id);

    if (selectedDeviceAlert) {
      return {
        ...selectedDevice,
        alertOn: selectedDeviceAlert.alertOn
      };
    }

    return selectedDevice;
  });

  return deviceWithAlerts;
};

export const getSaveMessage = (data = {}) => {
  const { formName } = data;
  const formNamesType = {
    DevicesApplianceForm: 'application',
    ShipmentCargoForm: 'shipment',
    EditProjectForm: 'project'
  };

  const form = formNamesType[formName] ?? 'project';

  return `Save the ${form} to apply the changes.`;
};
